var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedwarninng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5107 18.3759C50.6954 31.3822 37.803 15.7586 24.2685 23.5696C10.7341 31.3805 3.89039 43.2022 0.705626 30.1959C-2.47914 17.1897 5.41676 4.00001 18.3416 0.736013C31.2665 -2.52799 44.3259 5.36967 47.5107 18.3759Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.209 39.2255H11.5781C10.648 39.2255 9.81419 38.7451 9.34776 37.9404C8.89087 37.152 8.88389 36.2222 9.32855 35.389L21.6441 12.3193C22.0851 11.4932 22.9261 11 23.8936 11C24.8611 11 25.702 11.4932 26.1431 12.3193L38.4586 35.389C38.9034 36.2221 38.8964 37.1521 38.4394 37.9404C37.973 38.7451 37.1393 39.2255 36.209 39.2255Z",
    fill: "#FF4C04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4586 35.389L26.1431 12.3193C25.702 11.4932 24.8611 11 23.8936 11V39.2255H36.2091C37.1393 39.2255 37.9731 38.7451 38.4394 37.9404C38.8963 37.1521 38.9033 36.2221 38.4586 35.389Z",
    fill: "#E10000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8938 35.4432C22.6101 35.4432 21.5657 34.3989 21.5657 33.1152C21.5657 31.8315 22.6101 30.7871 23.8938 30.7871C25.1775 30.7871 26.2218 31.8315 26.2218 33.1152C26.2218 34.3989 25.1775 35.4432 23.8938 35.4432Z",
    fill: "#FFF3F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8938 28.4602C22.6101 28.4602 21.5657 27.4158 21.5657 26.1321V21.0976C21.5657 19.8139 22.6101 18.7695 23.8938 18.7695C25.1775 18.7695 26.2218 19.8139 26.2218 21.0976V26.1321C26.2218 27.4158 25.1775 28.4602 23.8938 28.4602Z",
    fill: "#FFF3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8936 18.7695H23.8936V28.4602H23.8937C25.1774 28.4602 26.2217 27.4158 26.2217 26.1321V21.0976C26.2217 19.814 25.1773 18.7695 23.8936 18.7695Z",
    fill: "#DAD0CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8936 30.7871H23.8936V35.4432H23.8936C25.1773 35.4432 26.2217 34.3989 26.2217 33.1152C26.2217 31.8315 25.1773 30.7871 23.8936 30.7871Z",
    fill: "#DAD0CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedwarninng);
export default __webpack_public_path__ + "static/media/redwarninng.947bbe4e96d5fe60eb836afed405c222.svg";
export { ForwardRef as ReactComponent };